export const ActionType = {
    LOGIN_MODAL_OPEN: "MODAL_OPEN",
    LOGIN_MODAL_CLOSE: "MODAL_CLOSE",
    TOKEN_EXPIRED: "TOKEN_EXPIRED",
    TOKEN_REFRESHED: "TOKEN_REFRESHED",
    IS_PAGE_RELOAD: "IS_PAGE_RELOAD"
}
